<template>
<div class="chapter">
<div class="inner_page">
<p class="fpara2"><a id="page_vi"></a><a id="page_vii"></a>The Curfew tolls the Knell of parting Day,</p>
<p class="fpara">The lowing Herd winds slowly o’er the Lea,</p>
<p class="fpara">The Plow-man homeward plods his weary Way,</p>
<p class="fpara">And leaves the World to Darkness, and to me.</p>
<p class="fpara1">Thomas Gray, <em class="italic">Elegy Written in a Country Church-Yard</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Front1.vue?dac61680